import type { PinnedApp } from '~/components/page/Widget/state/pinnedApps';

type Args = {
  id: string;
  weight: number;
};

const generatePinnedItem = ({ id, weight }: Args): PinnedApp => ({
  id,
  pinned: {
    __typename: 'WidgetSettingsPinned',
    enabled: true,
    weight,
  },
});

export default generatePinnedItem;
